// Entry point for the build script in your package.json

// Window animation
import WindowAnimation from "./lib/WindowAnimation";
WindowAnimation.start();

// Responsive embeds
import responsiveEmbeds from "./lib/responsiveEmbeds";
responsiveEmbeds();

// Grid overlay
import gridOverlay from "./lib/gridOverlay";
gridOverlay();

// Stimulus
import { Application } from "stimulus";
import ExpandableController from "./controllers/ExpandableController";
import HeaderController from "./controllers/HeaderController";
import MittFrieOrdFormController from "./controllers/MittFrieOrdFormController";
const application = Application.start();
application.register("expandable", ExpandableController);
application.register("header", HeaderController);
application.register("mitt-frie-ord-form", MittFrieOrdFormController);

// React
import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);
